export enum Message {
  Error = 'Something went wrong',
  NoPeople = 'There are no people on the server',
  Missmatch = 'There are no people matching the current search criteria',
}
